/*
 * Project: BookingEngine
 * Module: components/icons/CloseIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ onClick, className }) => (
  <svg className={`svg-icon ${className}`} width="12px" height="12px" viewBox="0 0 28 28" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={onClick}>
    <circle cx="14" cy="14" r="14" fill="#D9D9D9"/>
    <rect x="21.2637" y="5" width="3" height="23" transform="rotate(45 21.2637 5)" fill="#2E608E"/>
    <rect x="5" y="7.12134" width="3" height="23" transform="rotate(-45 5 7.12134)" fill="#2E608E"/>
  </svg>
);

CloseIcon.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

CloseIcon.defaultProps = {
  className: 'close-icon',
  onClick: () => {},
};

export default CloseIcon;
